// removed by extract-text-webpack-plugin
module.exports = {"mapEchart":"geography_mapEchart_1CpKq","trendEchart":"geography_trendEchart_1oQ35","pieEchart":"geography_pieEchart_1fjbg","progressList":"geography_progressList_11ND_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/financialOverview/geography.scss
// module id = 1563
// module chunks = 0